export default "__VITE_ASSET__DaMTrfZm__"